import {IItemContent, ItemFactory} from "@connox/typescript-library";
import React, {Suspense, useEffect, useState} from "react";
import ReactDOM from "react-dom";
import window from "../lib/WindowExtended";
import {getShopId} from "../lib/getShopId";
import {useTranslation} from "react-i18next";
import ErrorBoundary from "../utils/ErrorBoundary";
import SwiperConstruct from "../organisms/crossSelling/SwiperConstruct";
import ListItemCard from "../organisms/productList/ListItemCard";

const ProductSeriesPortalComponent: React.FC<{element: HTMLElement}> = ({element}) => {
  const {t} = useTranslation();
  const categoryId = Number(element.dataset.parentCategoryId ?? "0");
  const parentName = element.dataset.name;
  const url = element.dataset.categoryUrl;
  const limit = Number(element.dataset.limit ?? "0");
  const currencyCode: string = window.c_ActiveCurrency;
  const [items, setItems] = useState<IItemContent[]>([]);

  useEffect(() => {
    void ItemFactory.getItems(getShopId(), {currencyCode, categoryId, limit}).then((data) => {
      setItems(data.itemContent);
    });
  }, []);

  if (!items.length) {
    return null;
  }

  return (
    <SwiperConstruct
      link={
        url && parentName && (
          <a href={url} className={"swiper-cross-selling__title"}>
            {t("product.showItemsFrom--name", {name: parentName})}
          </a>
        )
      }
      title={t("product.discoverProductLine--name", {name: parentName})}
    >
      {items.map((item, key) => {
        return <ListItemCard key={key} item={item} />;
      })}
    </SwiperConstruct>
  );
};

const ProductSeriesPortal: React.FC = () => {
  const parentCategoriesElement = document.getElementById("ParentCategoryProductsContainer");

  if (!parentCategoriesElement) {
    return null;
  }

  return ReactDOM.createPortal(
    <ErrorBoundary fallback={null} occurrence="ProductSeriesPortal">
      <Suspense>
        <ProductSeriesPortalComponent element={parentCategoriesElement} />
      </Suspense>
    </ErrorBoundary>,
    parentCategoriesElement,
  );
};

export default ProductSeriesPortal;
